import {
    buildConfigSlice,
    useConfigSlice,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialVenueAnalysisCapsuleConfigState,
    VenueAnalysisCapsuleConfigState,
} from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { selectOrderLiquidityCapsuleState } from 'widgets/venueAnalysis/capsules/orderLiquidityCapsule/store/selectors.ts';

export const buildOrderLiquidityCapsuleConfigSlice = () =>
    buildConfigSlice<VenueAnalysisCapsuleConfigState>(
        WidgetType.ORDER_LIQUIDITY_CAPSULE,
        selectOrderLiquidityCapsuleState,
        initialVenueAnalysisCapsuleConfigState
    );

export const useOrderLiquidityCapsuleConfigSlice = () =>
    useConfigSlice(buildOrderLiquidityCapsuleConfigSlice());
